import * as React from "react"
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField, Tooltip } from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Check, Close} from "@material-ui/icons";
import "./InformacoesSelloutModal.scss";

export interface IInformacoesSelloutModalPros {
  item: any; 
}

const InformacoesSelloutModal:React.FC<IInformacoesSelloutModalPros> = (props) => { 
  const { item } = props
  const [open, setOpen] = useState<boolean>(false)      

  const onClose = () => {
    setOpen(false)
  }
  return (
    <div className="info-detalhes">
      <IconButton
        component={"span"}
        onClick={() => setOpen(true)}
        className="filter-dialog-close"
        color="primary"
        >
        <Tooltip title="Detalhes da Venda">
          <VisibilityIcon />
        </Tooltip>
      </IconButton> 
      {item && item.ind_integrado && (   
        <IconButton
          component={"span"} 
          className="ind-integrado-sellout"               
        >
          <Tooltip title={'Integrado :' + item.dta_processado}>
            <Check />
          </Tooltip>
        </IconButton> 
      )} 
    <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{ style: { width: "900px", maxWidth: "900px" } }}
    >
      <>
        <div className="title">
          <DialogTitle>{!!item.descricao ? item.descricao : ''}</DialogTitle>
          <IconButton onClick={onClose}><Close /></IconButton>
        </div>
        <DialogContent> 
        <div className="body" />
          <div className="footer-body">
            <div className="informacoes">
          <Grid container={true} spacing={16}>
            <Grid item={true} >
            <TextField
              label={"Número Cupom"}
              value={item.numero_cupom}
              // title={item.numero_cupom}
              inputProps={{ readOnly: true }}
              fullWidth={true}
              type="text"
            />
            <TextField
              label={"Série do Cupom"}
              value={item.serie_cupom}
              // title={value}
              inputProps={{ readOnly: true }}
              fullWidth={true}
              type="text"
            />
            <TextField
              label={"CFOP"}
              value={item.cfop}
              // title={value}
              inputProps={{ readOnly: true }}
              fullWidth={true}
              type="text"
            />
            <TextField
              label={"Número da Nota"}
              value={item.numero_nota}
              // title={item.value}
              inputProps={{ readOnly: true }}
              fullWidth={true}
              type="text"
            />             
            <TextField
                label={"Data Processado"}
                value={item.dta_processado}
                // title={item.value}
                inputProps={{ readOnly: true }}
                fullWidth={true}
                type="text"
              /> 
            <TextField
                label={"Integrado"}
                value={item.ind_integrado ? 'SIM' : 'NÂO'}
                // title={item.value}
                inputProps={{ readOnly: true }}
                fullWidth={true}
                type="text"
              /> 
             
            </Grid>
          </Grid>
          </div>
          </div>
        </DialogContent>
      </>
  </Dialog>
  </div>
  );
}

export default InformacoesSelloutModal


// WEBPACK FOOTER //
// ./src/component/administration/informacoesSellout/InformacoesSelloutModal.tsx